import Box from '@mui/material/Box'

/**
 * Bandeiras em SVG inline (Brasil, EUA, Espanha) para o seletor de idioma.
 * SVG em vez de emoji: renderiza igual em qualquer SO (o Windows não desenha
 * emoji de bandeira) e mantém a nitidez em qualquer tamanho.
 */
export type FlagCode = 'br' | 'us' | 'es'

const SHAPES: Record<FlagCode, React.ReactNode> = {
  br: (
    <>
      <rect width="28" height="20" fill="#009B3A" />
      <path d="M14 2.6 L25.4 10 L14 17.4 L2.6 10 Z" fill="#FEDF00" />
      <circle cx="14" cy="10" r="4.1" fill="#002776" />
    </>
  ),
  us: (
    <>
      <rect width="28" height="20" fill="#FFFFFF" />
      <g fill="#B22234">
        <rect y="0" width="28" height="1.538" />
        <rect y="3.077" width="28" height="1.538" />
        <rect y="6.154" width="28" height="1.538" />
        <rect y="9.231" width="28" height="1.538" />
        <rect y="12.308" width="28" height="1.538" />
        <rect y="15.385" width="28" height="1.538" />
        <rect y="18.462" width="28" height="1.538" />
      </g>
      <rect width="11.2" height="10.77" fill="#3C3B6E" />
    </>
  ),
  es: (
    <>
      <rect width="28" height="20" fill="#AA151B" />
      <rect y="5" width="28" height="10" fill="#F1BF00" />
    </>
  ),
}

export function Flag({ code, size = 24 }: { code: FlagCode; size?: number }) {
  const width = size
  const height = Math.round((size * 20) / 28)
  return (
    <Box
      sx={{
        width,
        height,
        borderRadius: '3px',
        overflow: 'hidden',
        lineHeight: 0,
        flex: '0 0 auto',
        boxShadow: 'inset 0 0 0 1px rgba(0, 0, 0, 0.14)',
      }}
    >
      <svg width={width} height={height} viewBox="0 0 28 20" preserveAspectRatio="none" aria-hidden="true">
        {SHAPES[code]}
      </svg>
    </Box>
  )
}
